var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.9375C5.5332 3.9375 3.9375 5.57031 3.9375 7.5C3.9375 9.4668 5.5332 11.0625 7.5 11.0625C9.42969 11.0625 11.0625 9.4668 11.0625 7.5C11.0625 5.57031 9.42969 3.9375 7.5 3.9375ZM7.5 9.875C6.16406 9.875 5.125 8.83594 5.125 7.5C5.125 6.20117 6.16406 5.125 7.5 5.125C8.79883 5.125 9.875 6.20117 9.875 7.5C9.875 8.83594 8.79883 9.875 7.5 9.875ZM7.5 0.375C3.5293 0.375 0.375 3.56641 0.375 7.5C0.375 10.3945 1.33984 11.2109 6.75781 19.0039C7.0918 19.5234 7.87109 19.5234 8.20508 19.0039C13.623 11.2109 14.625 10.3945 14.625 7.5C14.625 3.56641 11.4336 0.375 7.5 0.375ZM7.5 17.9648C2.30469 10.5059 1.5625 9.91211 1.5625 7.5C1.5625 5.94141 2.15625 4.45703 3.26953 3.30664C4.41992 2.19336 5.9043 1.5625 7.5 1.5625C9.05859 1.5625 10.543 2.19336 11.6934 3.30664C12.8066 4.45703 13.4375 5.94141 13.4375 7.5C13.4375 9.91211 12.6582 10.5059 7.5 17.9648Z",
    fill: "#DFE2E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyLocation);
export default __webpack_public_path__ + "static/media/greyLocation.57b0cac6.svg";
export { ForwardRef as ReactComponent };